import type { ServerConfig } from 'shared-types';

type RouteRule = {
  isDisabled: (serverConfig: ServerConfig) => boolean;
  prefixes: string[];
};

const DISABLED_ROUTE_RULES: RouteRule[] = [
  {
    isDisabled: (sc) => sc.platformCompetenciesOnly,
    prefixes: [
      '/analytics/completion-matrix',
      '/analytics/completions',
      '/my-team/completion-matrix',
      '/my-team/completions',
      '/my-team/review',
      '/profile/completions',
      '/profile/summary-email',
      '/users/[userId]/completions'
    ]
  },
  {
    isDisabled: (sc) => sc.hideAchievementsFromUI,
    prefixes: [
      '/achievements',
      '/admin/achievements',
      '/my-team/follow/achievements',
      '/my-team/follow/pending-requests',
      '/profile/achievements',
      '/users/[userId]/achievements'
    ]
  },
  {
    isDisabled: (sc) => sc.hideCalendarEventsFromUI,
    prefixes: ['/calendar', '/my-team/follow/calendar-events']
  },
  {
    isDisabled: (sc) => sc.hideCoursesFromUI,
    prefixes: [
      '/admin/courses',
      '/admin/settings/courses',
      '/analytics/courses',
      '/courses',
      '/groups/[groupId]/courses',
      '/groups/[groupId]/follow',
      '/join/courses',
      '/login/courses',
      '/my-team/follow/courses',
      '/profile/courses',
      '/profile/feedbacks',
      '/users/[userId]/courses',
      '/users/[userId]/feedbacks'
    ]
  },
  {
    isDisabled: (sc) => sc.hidePathsFromUI,
    prefixes: [
      '/admin/paths',
      '/analytics/paths',
      '/join/paths',
      '/login/paths',
      '/my-team/follow/paths',
      '/paths',
      '/profile/paths',
      '/users/[userId]/paths'
    ]
  }
];

const routeMatchesPrefix = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

const isRouteDisabled = (pathname: string, serverConfig: ServerConfig) =>
  DISABLED_ROUTE_RULES.some(
    (rule) =>
      rule.isDisabled(serverConfig) &&
      rule.prefixes.some((prefix) => routeMatchesPrefix(pathname, prefix))
  );

export default isRouteDisabled;
